(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ProductoFormController', ProductoFormController);


    ProductoFormController.$inject = [
        '$stateParams',
        'productoService',
        'clientService',
        'genericDataService',
        '$state',
        'notificationService',
        'common',
        'zonaService'
    ];

    function ProductoFormController(
        $stateParams,
        productoService,
        clientService,
        genericDataService,
        $state,
        notificationService,
        common,
        zonaService
    ) {
        // jshint maxstatements:false
        var id = $stateParams.id;

        var vm = this;
        vm.product = {};

        vm.stateParams = $stateParams;

        vm.fields = vm.fields;

        vm.andType = 'string';
        vm.andOperations = [];
        vm.andOptions = [];

        vm.orType = 'string';
        vm.orOperations = [];
        vm.orOptions = [];

        vm.newAndCondition = {};
        vm.newOrCondition = {};

        vm.andConditions = [];
        vm.orConditions = [];

        vm.genericData = {
            impuestos: { list: [] },
            unidadesMedida: { list: [] },
            tipo: {
                list: [
                    { id: 'S', nombre: 'Servicio' },
                    { id: 'A', nombre: 'Artículo' },
                    { id: 'G', nombre: 'Gasto Suplido' },
                    { id: 'R', nombre: 'Recorrido' }
                ]
            },
            metodoCalculo: {
                list: [
                    { id: 'I', nombre: 'Importe' },
                    { id: 'P', nombre: 'Porcentaje' }
                ]
            },
            zonas: {
                list: [],
                loading: false,
                source: {
                    zonaId: null,
                    descripcion: ''
                },
                destination: {
                    zonaId: null,
                    descripcion: ''
                },
                habilitarIdaVuelta: true
            }
        };

        vm.save = save;
        vm.saveAndNew = saveAndNew;
        vm.saveAndClose = saveAndClose;

        vm.selectedAction = 0;
        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.tipoOnChange = tipoOnChange;

        /* INITIALIZER */
        (function () {

            clientService.getTarifaFields().then(function (result) {
                var fields = [];
                vm.filterData = {};
                result.data.forEach(f => {
                    fields.push({ id: f.fieldId, nombre: clientService.fieldNames[f.fieldId] });
                    vm.filterData[f.fieldId] = f;
                    vm.filterData[f.fieldId].nombre = clientService.fieldNames[f.fieldId];
                });
                vm.fields = fields;
                getProduct();
            });

            getGenericData();

        })();

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            var action = 'saveAndNew';
            doSave(action);
        }

        function findOpById(operations, id) {
            var result = operations.filter(obj => {
                return obj.id === id;
            });
            return result[0] || null;
        }

        function doSave(action) {

            if (vm.edit && (vm.product.id === null || vm.product.id === '' || vm.product.id === undefined)) {
                sendErrorRequire();
                return;
            }

            var andConds = vm.andConditions.map(function (cond) {
                return {
                    field: cond.field.id,
                    operation: cond.operation.id,
                    value: cond.value.id || cond.value
                };
            });

            var orConds = [];

            if (vm.genericData.tipo.selected.id != 'R') {
                orConds = vm.orConditions.map(function (cond) {
                    return {
                        field: cond.field.id,
                        operation: cond.operation.id,
                        value: cond.value.id || cond.value
                    };
                });
            } 

            productoService
                .addProduct(vm.product, andConds, orConds, vm.genericData.zonas.habilitarIdaVuelta, vm.genericData.zonas.source.zonaId, vm.genericData.zonas.destination.zonaId)
                .then(function (productoSave) {
                    sendSaveNotification();
                    vm.edit = true;
                    if (action === 'saveAndClose') {
                        $state.go('flota.configuracion.listadoproductos');
                    }
                    else if (action === 'saveAndNew') {
                        $state.go('flota.configuracion.nuevoProducto', { 'accion': 'saveAndNew' });
                    }
                    else {
                        vm.product.id = productoSave.data.product.id;
                        vm.product.productoId = productoSave.data.product.productoId;
                        //$state.reload();
                    }
                });
        }

        function getProduct() {
            if (id != null) {
                vm.edit = true;
                productoService.getProduct(id)
                    .then(function (res) {
                        vm.product = res.data.product;
                        vm.product.descripcion = vm.product.descripcion.trim();
                        vm.product.id = vm.product.id.trim();
                        vm.genericData.zonas.habilitarIdaVuelta = res.data.habilitarIdaVuelta;
                        vm.genericData.zonas.source.zonaId = res.data.zonaIdSource;
                        vm.genericData.zonas.destination.zonaId = res.data.zonaIdDestination;

                        vm.andConditions = res.data.andConditions.map(function (cond) {
                            var field = vm.filterData[cond.field];
                            var ops = clientService.operations[field.type];
                            return {
                                field: { nombre: field.nombre, id: cond.field },
                                operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                                value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                                type: field.type
                            };
                        });
                        vm.orConditions = res.data.orConditions.map(function (cond) {
                            var field = vm.filterData[cond.field];
                            var ops = clientService.operations[field.type];
                            return {
                                field: { nombre: field.nombre, id: cond.field },
                                operation: { nombre: findOpById(ops, cond.operation).nombre, id: cond.operation },
                                value: field.type === 'options' ? findOpById(field.options, cond.value) : cond.value,
                                type: field.type
                            };
                        });
                    });
            }
        }

        function getGenericData() {
            vm.genericData.impuestos.loading = true;
            genericDataService.getImpuestos()
                .then(function (res) {
                    vm.genericData.impuestos.loading = false;
                    vm.genericData.impuestos.list = res;
                    vm.genericData.impuestos.selected = vm.genericData.impuestos.list[0];
                });

            vm.genericData.unidadesMedida.loading = true;
            genericDataService.getUnidadesMedida()
                .then(function (res) {
                    vm.genericData.unidadesMedida.loading = false;
                    vm.genericData.unidadesMedida.list = res;
                    vm.genericData.unidadesMedida.selected = vm.genericData.unidadesMedida.list[0];
                });

            vm.genericData.tipo.selected = vm.genericData.tipo.list[0];
            vm.genericData.metodoCalculo.selected = vm.genericData.metodoCalculo.list[0];

            vm.genericData.zonas.loading = true;
            zonaService.getList()
                .then(function (res) {
                    vm.genericData.zonas.loading = false;
                    vm.genericData.zonas.list = res.data.list;
                });
        }

        //#region Condiciones
        vm.addAndCondition = function () {
            if (common.isNullOrUndefined(vm.filterData[vm.newAndCondition.field.id])) { return; }
            var type = vm.filterData[vm.newAndCondition.field.id].type;

            if (vm.newAndCondition.field.id && vm.newAndCondition.operation.id &&
                ((type === 'options' && vm.newAndCondition.value.id) || (type !== 'options' && vm.newAndCondition.value))) {
                var condition = {
                    field: vm.newAndCondition.field,
                    operation: vm.newAndCondition.operation,
                    value: vm.newAndCondition.value,
                    type: vm.filterData[vm.newAndCondition.field.id].type
                };
                vm.andConditions.push(condition);
                vm.newAndCondition = {};
            }
        };

        vm.removeAndCondition = function (index) {
            vm.andConditions.splice(index, 1);
        };

        vm.addOrCondition = function () {
            if (common.isNullOrUndefined(vm.filterData[vm.newOrCondition.field.id])) { return; }
            var type = vm.filterData[vm.newOrCondition.field.id].type;

            if (vm.newOrCondition.field.id && vm.newOrCondition.operation.id &&
                ((type === 'options' && vm.newOrCondition.value.id) || (type !== 'options' && vm.newOrCondition.value))) {
                var condition = {
                    field: vm.newOrCondition.field,
                    operation: vm.newOrCondition.operation,
                    value: vm.newOrCondition.value,
                    type: vm.filterData[vm.newOrCondition.field.id].type
                };
                vm.orConditions.push(condition);
                vm.newOrCondition = {};
            }
        };

        vm.removeOrCondition = function (index) {
            vm.orConditions.splice(index, 1);
        };

        vm.onAndConditionFieldChange = function (field) {
            if (common.isNullOrUndefined(field) || common.isNullOrUndefined(field.id)) {
                vm.andOperations = null;
                vm.andOptions = null;
                vm.newAndCondition = {};
                return;
            }

            var type = vm.filterData[field.id].type;

            vm.andOperations = clientService.operations[type];
            vm.newAndCondition.operation = vm.andOperations[0];

            if (type === 'options') {
                vm.andOptions = vm.filterData[field.id].options;
            }
        };

        vm.onOrConditionFieldChange = function (field) {
            if (common.isNullOrUndefined(field) || common.isNullOrUndefined(field.id)) {
                vm.orOperations = null;
                vm.orOptions = null;
                vm.newOrCondition = {};
                return;
            }

            var type = vm.filterData[field.id].type;
            vm.orOperations = clientService.operations[type];
            vm.newOrCondition.operation = vm.orOperations[0];

            if (type === 'options') {
                vm.orOptions = vm.filterData[field.id].options;
            }
        };
        //#endregion

        function computeValueAccionSelected(accion) {

            if (accion === vm.stateParams.accion) {
                return true;
            }

            return false;
        }

        function sendSaveNotification() {
            notificationService.sendAppNotification({
                message: 'El producto se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'El campo Id es obligatorio',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }

        vm.toggleVisibility = function (className) {

            var elements = document.getElementsByClassName(className);

            for (var i = 0; i < elements.length; i++) {
                var obj = elements[i];

                if (obj.classList.contains('none')) {
                    obj.classList.remove('none');
                } else {
                    obj.classList.add('none');
                }
            }
        }

        vm.conditionsCount = function () {
            var conditionsCnt = vm.andConditions.length + vm.orConditions.length;
            return conditionsCnt;
        };

        vm.conditionsCountHumanized = function () {
            var conditionsCnt = vm.andConditions.length + vm.orConditions.length;

            if (conditionsCnt == 0) {
                return '';
            } else {
                if (conditionsCnt > 1) {
                    return conditionsCnt + ' condiciones';
                } else {
                    return '1 condición';
                }
            }
        };

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if (!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

        function tipoOnChange() {
            //console.log(vm.genericData.tipo.selected);
            //if (vm.genericData.tipo.selected.id == 'R') {
            //} else {
            //}
            //vm.genericData.tipo.selected.id == 'R'
        }

    }

})();

